module.exports = __webpack_public_path__ + "img/big-tickmark.f76ea7ce.svg";